module.exports = __webpack_public_path__ + "img/e0b46e2.svg";